export default __webpack_public_path__ + "static/media/Meru's Grand Staff.4e977c72.jpg";